import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import { serchSelect, tabulation } from "@/mixins/index";
import { getEntries, publishEntry, rollbackEntry, disableEntry } from "@/api/chatbot/chatbot";
import addDocumetItem from './components/addDocumetItem.vue';
import reviewDocument from './components/reviewDocument.vue';
export default {
  name: "documentList",
  mixins: [serchSelect, tabulation],
  components: {
    addDocumetItem: addDocumetItem,
    reviewDocument: reviewDocument
  },
  data: function data() {
    return {
      kindList: [{
        label: '全部',
        value: ''
      }, {
        label: 'table_description',
        value: 'table_description'
      }, {
        label: 'field_alias',
        value: 'field_alias'
      }, {
        label: 'entity_mapping',
        value: 'entity_mapping'
      }, {
        label: 'ownership_doc',
        value: 'ownership_doc'
      }, {
        label: 'fixed_filter',
        value: 'fixed_filter'
      }, {
        label: 'metric_definition',
        value: 'metric_definition'
      }, {
        label: 'example_sql',
        value: 'example_sql'
      }, {
        label: 'global_policy',
        value: 'global_policy'
      }, {
        label: 'metric_policy',
        value: 'metric_policy'
      }, {
        label: 'data_model_policy',
        value: 'data_model_policy'
      }, {
        label: 'feedback_note',
        value: 'feedback_note'
      }],
      documentTypeList: [{
        label: '全部',
        value: ''
      }, {
        label: 'Schema 配置',
        value: 'schema_config'
      }, {
        label: '关联文档',
        value: 'related_doc'
      }, {
        label: '字段映射明细',
        value: 'field_mapping_detail'
      }, {
        label: '归属文档',
        value: 'ownership_doc'
      }, {
        label: '归属/属性文档',
        value: 'entity_attribute_doc'
      }, {
        label: '业务规则',
        value: 'business_policy'
      }, {
        label: '示例 SQL',
        value: 'example_sql_doc'
      }, {
        label: '反馈候选',
        value: 'feedback_candidate'
      }],
      searchData: {
        page: 1,
        limit: 80
      },
      tableData: [],
      allTableData: [],
      reviewMap: {}
    };
  },
  created: function created() {},
  computed: {},
  methods: {
    searchClick: function searchClick(e) {
      var _this = this;

      if (e == 1) {
        this.searchData.page = 1;
      }

      this.reqLoading = true;
      getEntries(this.searchData).then(function (res) {
        var items = res.items || [];
        var impactSummaries = res.impact_summaries || {}; // 2. 循环加工映射数据

        var processedItems = items.map(function (item) {
          var _item$metadata, _item$metadata2, _item$metadata3;

          var embStatus = ((_item$metadata = item.metadata) === null || _item$metadata === void 0 ? void 0 : _item$metadata.embedding_status) || '-';
          var embModel = item.embedding_model || '/';
          var embDim = ((_item$metadata2 = item.metadata) === null || _item$metadata2 === void 0 ? void 0 : _item$metadata2.embedding_dimensions) ? item.metadata.embedding_dimensions + 'd' : '/';
          item._embeddingStr = "".concat(embStatus, " / ").concat(embModel, " / ").concat(embDim); // B. 提取对应关系（根据返回结构看，有的在 metadata 里面，有的在根目录，做兼容处理）

          item.relation_type = item.relation_type || ((_item$metadata3 = item.metadata) === null || _item$metadata3 === void 0 ? void 0 : _item$metadata3.relation_type) || ''; // C. 处理【影响面】：根据 entry_id 匹配字典

          if (item.entry_id && impactSummaries[item.entry_id]) {
            item._impact = impactSummaries[item.entry_id];
          } else {
            item._impact = null;
          } // D. 处理【状态】：true -> enabled, false -> disabled


          item._statusStr = item.enabled ? 'enabled' : 'disabled';

          if (item.metadata) {
            var rawTags = item.tags || '';
            item.tags = Array.isArray(rawTags) ? rawTags.join(',') : String(rawTags);
          } // 3. 从匹配到的影响面数据 (_impact) 提取拓扑与策略字段，拍平到最外层


          if (item._impact) {
            item.table_name = item._impact.target_tables ? item._impact.target_tables.join(',') : '';
            item.column_name = item._impact.target_columns ? item._impact.target_columns.join(',') : '';
            item.schema_linking_focus = item._impact.schema_linking_focus !== undefined ? String(item._impact.schema_linking_focus) : '';
            item.related_tables = item._impact.related_tables ? item._impact.related_tables.join(',') : '';
            item.related_columns = item._impact.related_columns ? item._impact.related_columns.join(',') : '';
            item.context_columns = item._impact.context_columns ? item._impact.context_columns.join(',') : '';
            item.generator_context_max_chars = item._impact.generator_context_max_chars || 0;
            item.generator_summary = item._impact.generator_summary || '';
          } else {
            item.table_name = '';
            item.column_name = '';
            item.schema_linking_focus = '';
            item.related_tables = '';
            item.related_columns = '';
            item.context_columns = '';
            item.generator_context_max_chars = 0;
            item.generator_summary = '';
          } // 5. 元数据 JSON 串回显（转回字符串供 textarea 编辑）


          if (item.metadata) {
            try {
              item.metadata_json = JSON.stringify(item.metadata, null, 2);
            } catch (e) {
              item.metadata_json = '';
            }
          } else {
            item.metadata_json = '';
          }

          item.keywords = item.keywords ? item.keywords.join(',') : '';
          return item;
        });
        processedItems.sort(function (a, b) {
          var timeA = a.created_at ? new Date(a.created_at).getTime() : 0;
          var timeB = b.created_at ? new Date(b.created_at).getTime() : 0;
          return timeB - timeA;
        });
        _this.allTableData = processedItems;

        _this.renderCurrentPageData(); // 分页断言：如果返回的条数等于期望的 limit 条数，说明潜在还有下一页
        //this.hasMore = items.length === this.searchData.limit;

      }).finally(function () {
        _this.reqLoading = false;
      });
    },
    renderCurrentPageData: function renderCurrentPageData() {
      var start = (this.searchData.page - 1) * this.searchData.limit;
      var end = start + this.searchData.limit;
      this.tableData = this.allTableData.slice(start, end);
      this.hasMore = this.allTableData.length > end;
    },
    changePage: function changePage(targetPage) {
      if (targetPage < 1) return;
      this.searchData.page = targetPage;
      this.renderCurrentPageData();
    },
    // 切换单页条数事件
    sizeChange: function sizeChange(val) {
      this.searchData.limit = val;
      this.searchData.page = 1;
      this.renderCurrentPageData();
    },
    getReviewId: function getReviewId(payload) {
      console.log("payload==", payload);
      var review_id = payload.review_id,
          entry_id = payload.entry_id;

      if (entry_id) {
        this.$set(this.reviewMap, entry_id, review_id);
        this.searchClick(1);
      }
    },
    handlePublishEntry: function handlePublishEntry(row) {
      var _this2 = this;

      var currentReviewId = this.reviewMap[row.entry_id];

      if (!currentReviewId) {
        this.$message.warning("该文档尚未进行审核或关联审核失效，请先点击 'Review' ！");
        return;
      }

      this.$confirm("此操作将发布该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return publishEntry({
                  review_id: currentReviewId,
                  entry_id: row.entry_id
                });

              case 2:
                res = _context.sent;

                if (res.detail) {
                  _this2.$message({
                    type: "error",
                    message: res.detail
                  });
                } else {
                  _this2.$message({
                    type: "success",
                    message: '发布成功'
                  });

                  _this2.searchClick(1);
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    },
    handleRollbackEntry: function handleRollbackEntry(row) {
      var _this3 = this;

      var currentReviewId = this.reviewMap[row.entry_id];

      if (!currentReviewId) {
        this.$message.warning("该文档尚未进行审核或关联审核失效，请先点击 'Review' 提交！");
        return;
      }

      this.$confirm("此操作将回滚该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return rollbackEntry({
                  review_id: currentReviewId,
                  entry_id: row.entry_id
                });

              case 2:
                res = _context2.sent;
                console.log("res===", res);

                if (res.detail) {
                  _this3.$message({
                    type: "error",
                    message: res.detail
                  });
                } else {
                  _this3.$message({
                    type: "success",
                    message: '回滚成功'
                  });

                  _this3.searchClick(1);
                }

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })));
    },
    handleDisableEntry: function handleDisableEntry(row) {
      var _this4 = this;

      this.$confirm("此操作将禁用该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return disableEntry({
                  entry_id: row.entry_id
                });

              case 2:
                res = _context3.sent;

                if (res.detail) {
                  _this4.$message({
                    type: "error",
                    message: res.detail
                  });
                } else {
                  _this4.$message({
                    type: "success",
                    message: '禁用成功'
                  });

                  _this4.searchClick(1);
                }

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      })));
    }
  }
};